<template>
    <div class="bg-body-tertiary min-vh-100 d-flex flex-row align-items-center">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-6 text-center">
                    <div class="clearfix">
                        <h1 class="display-3 mx-auto">
                            500
                        </h1>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center mb-4">
                <div class="col-md-6 text-center">
                    <div class="clearfix">
                        <h4 class="pt-3">
                            {{ __('messages.error_page.error', {error: errorMessage}) }}
                        </h4>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center mb-2">
                <div class="col-md-6 text-center">
                    <div class="clearfix">
                        <div class="pt-3">
                            <span>{{ __('messages.error_page.support_link') }}</span>
                            <a
                                :href="supportUrl"
                                target="_blank"
                            >Jira</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center mb-2">
                <div class="col-md-6 text-center">
                    <div class="clearfix">
                        <div class="pt-3">
                            <Link href="/">
                                {{ __('messages.error_page.dashboard_link') }}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-md-6 text-center">
                    <div class="clearfix">
                        <div class="pt-3">
                            {{ __('messages.error_page.request_id_text') }}
                        </div>
                        <div class="pt-1">
                            {{ requestId }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ErrorBase from '~@/Pages/Errors/ErrorBase'

export default {
    layout: [ErrorBase]
}
</script>

<script setup>
defineProps({
    errorMessage: {
        type: String,
        default: ''
    },
    supportUrl: {
        type: String,
        default: ''
    },
    requestId: {
        type: String,
        default: ''
    }
})
</script>
